module.exports = __webpack_public_path__ + "static/media/snow-blowing.2f900299.svg";